// extracted by mini-css-extract-plugin
export default {"course-template":"styles_course-template__gpI2l","course-nav":"styles_course-nav__GjMnW"};